import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const MoreIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.136 9.333C5.68 9.333 4.5 10.527 4.5 12c0 1.473 1.18 2.667 2.636 2.667 1.456 0 2.637-1.194 2.637-2.667 0-1.473-1.18-2.667-2.637-2.667zm0 9.334c-1.456 0-2.636 1.194-2.636 2.666C4.5 22.806 5.68 24 7.136 24c1.456 0 2.637-1.194 2.637-2.667 0-1.472-1.18-2.666-2.637-2.666zm9.228-13.334C17.82 5.333 19 4.14 19 2.667 19 1.194 17.82 0 16.364 0c-1.456 0-2.637 1.194-2.637 2.667 0 1.472 1.18 2.666 2.637 2.666zM7.136 0C5.68 0 4.5 1.194 4.5 2.667c0 1.472 1.18 2.666 2.636 2.666 1.456 0 2.637-1.194 2.637-2.666 0-.708-.278-1.386-.772-1.886A2.621 2.621 0 0 0 7.136 0zm9.228 18.667c-1.456 0-2.637 1.194-2.637 2.666 0 1.473 1.18 2.667 2.637 2.667C17.82 24 19 22.806 19 21.333c0-1.472-1.18-2.666-2.636-2.666zm0-9.334c-1.456 0-2.637 1.194-2.637 2.667 0 1.473 1.18 2.667 2.637 2.667C17.82 14.667 19 13.473 19 12c0-1.473-1.18-2.667-2.636-2.667z"
        fillRule="evenodd"
      />
    </svg>
  )
})
